import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChild, Router, UrlTree } from '@angular/router';
import { AppState } from '@store/state/app.state';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs/operators';
import { selectUserProfileLimitsSelector } from '@store/selectors/profile-limits.selectors';
import { firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PlatformAccessGuard implements CanActivateChild {
	constructor(private readonly store: Store<AppState>, private readonly router: Router) {}

	async canActivate(route: ActivatedRouteSnapshot): Promise<boolean | UrlTree> {
		return this.checkAccess(route);
	}

	async canActivateChild(childRoute: ActivatedRouteSnapshot): Promise<boolean | UrlTree> {
		return this.checkAccess(childRoute);
	}

	private async checkAccess(route: ActivatedRouteSnapshot): Promise<boolean | UrlTree> {
		// Skip platform access check if route data specifies it
		if (route.data?.skipPlatformAccessCheck === true) {
			return true;
		}

		const profileLimits = await firstValueFrom(
			this.store
				.select(selectUserProfileLimitsSelector)
				.pipe(filter((profileLimitsState) => !!profileLimitsState)),
		);

		const platformAccess = profileLimits['platformAccess'];

		if (platformAccess) {
			return true;
		}

		return this.router.parseUrl('/access-denied');
	}
}
